/**
 * Aplica máscara de CPF (XXX.XXX.XXX-XX)
 */
export const maskCPF = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  return numbers
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    .slice(0, 14);
};

/**
 * Aplica máscara de telefone ((XX) XXXXX-XXXX)
 */
export const maskPhone = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  return numbers
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .slice(0, 15);
};

/**
 * Aplica máscara de cartão de crédito (XXXX XXXX XXXX XXXX)
 */
export const maskCreditCard = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  return numbers
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .slice(0, 19);
};

/**
 * Aplica máscara de CEP (XXXXX-XXX)
 */
export const maskCEP = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  return numbers
    .replace(/(\d{5})(\d)/, '$1-$2')
    .slice(0, 9);
};

/**
 * Handler para aplicar máscara de CPF em eventos onInput
 */
export const handleCpfMaskOnInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  target.value = maskCPF(target.value);
};

/**
 * Handler para aplicar máscara de cartão de crédito em eventos onInput
 */
export const handleCreditCardNumberMaskOnInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  target.value = maskCreditCard(target.value);
};

/**
 * Handler para aplicar máscara de data de expiração em eventos onInput
 */
export const handleCreditCardExpirationMaskOnInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  const value = target.value.replace(/\D/g, '');
  
  // ✅ FORMATO MM/YY (máximo 4 dígitos + 1 barra = 5 caracteres)
  if (value.length <= 4) {
    target.value = value
      .replace(/(\d{2})(\d)/, '$1/$2')
      .slice(0, 5);
  }
};

/**
 * Handler para aplicar máscara de CEP em eventos onInput
 */
export const handleCepMaskOnInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  target.value = maskCEP(target.value);
};

/**
 * Handler para aplicar máscara de telefone em eventos onInput
 */
export const handlePhoneMaskOnInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  target.value = maskPhone(target.value);
};

/**
 * Aplica máscara de data de nascimento (DD/MM/AAAA)
 */
export const maskBirthDate = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  return numbers
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .slice(0, 10);
};

/**
 * Handler para aplicar máscara de data de nascimento em eventos onInput
 */
export const handleBirthDateMaskOnInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  target.value = maskBirthDate(target.value);
}; 